import axios from "axios";
import moment from "moment";

/*

DO NOT DELETE: http://localhost:4502/libs/cq/search/content/querydebug.html

type=cq:Page
path=/content/arbormemorial/ca/en/dbancaster/obituaries
1_property=jcr:content/root/responsivegrid/obituary_detail/sling:resourceType
1_property.value=arbormemorial/components/obituary-detail

2_group.1_group.p.or=false

2_group.1_group.1_likeIgnoreCase.property: jcr:content/root/responsivegrid/obituary_detail/profile/deceasedName
2_group.1_group.1_likeIgnoreCase.value: %Jud%
2_group.1_group.1_likeIgnoreCase.operation: like

2_group.1_group.2_likeIgnoreCase.property: jcr:content/root/responsivegrid/obituary_detail/profile/deceasedName
2_group.1_group.2_likeIgnoreCase.value: %Jenner%
2_group.1_group.2_likeIgnoreCase.operation: like

3_daterange.property=jcr:content/root/responsivegrid/obituary_detail/profile/deceasedDeathDate
3_daterange.lowerBound=1944-05-19
3_daterange.upperBound=1964-05-20
4_daterange.property=jcr:content/root/responsivegrid/obituary_detail/profile/events/_/times/_/date
4_daterange.lowerBound=2022-03-05
4_daterange.upperBound=2022-05-20
p.hits=full
p.properties=root/responsivegrid/obituary_detail/profile/deceasedName,root/responsivegrid/obituary_detail/profile/events/_/times/_/startTime,root/responsivegrid/obituary_detail/profile/deceasedBirthDate,root/responsivegrid/obituary_detail/profile/deceasedDeathDate,root/responsivegrid/obituary_detail/profile/hideDob,root/responsivegrid/obituary_detail/profile/hideDod
*/

export interface IObitsSearchParams {
  name: string;
  minDate: string;
  maxDate: string;
  orderBy: "deceasedName" | "deceasedBirthDate" | "deceasedDeathDate";
  orderBySort: "asc" | "desc";
  searchPath: string;
  pageNumber: number;
  limit: number;
}

interface IObitsListingService {
  searchObits: any;
}
const buildNameQuery = (terms: string[]) => {
  const subqueries: string[] = [];

  terms.forEach((term, index) =>
    subqueries.push(
      `&2_group.1_group.${
        index + 1
      }_likeIgnoreCase.property=jcr:content/root/responsivegrid/obituary_detail/profile/deceasedName&2_group.1_group.${
        index + 1
      }_likeIgnoreCase.value=%25${term}%25&2_group.1_group.${
        index + 1
      }_likeIgnoreCase.operation=like`
    )
  );

  return subqueries.join("");
};

const getValidQuery = (params: IObitsSearchParams) => {
  const tomorrow = moment().add(1, "d").format("YYYY-MM-DD");
  const hundredYearsAgo = moment().subtract(100, "years").format("YYYY-MM-DD");
  const {
    name = "",
    minDate = hundredYearsAgo,
    maxDate = tomorrow,
    orderBy = "deceasedDeathDate",
    orderBySort = "desc",
    searchPath = "",
    pageNumber = 1,
    limit = 10,
  } = params;
  const offset = (pageNumber - 1) * limit;
  const searchTerms = name.trim().split(" ");
  const nameQuery = buildNameQuery(searchTerms);

  const validQuery = `type=cq:Page&path=${searchPath.replace(
    "ca/fr",
    "ca/en"
  )}&1_property=jcr:content/root/responsivegrid/obituary_detail/sling:resourceType&1_property.value=arbormemorial/components/obituary-detail&2_group.1_group.p.or=false${nameQuery}&3_daterange.property=jcr:content/root/responsivegrid/obituary_detail/profile/deceasedDeathDate&3_daterange.lowerBound=${minDate}&3_daterange.upperBound=${maxDate}&p.hits=full&p.properties=root/responsivegrid/obituary_detail/profile/deceasedName,root/responsivegrid/obituary_detail/profile/mediaEntries/*/imageThumbnailUrl,root/responsivegrid/obituary_detail/profile/deceasedBirthDate,root/responsivegrid/obituary_detail/profile/deceasedDeathDate,root/responsivegrid/obituary_detail/profile/hideDob,root/responsivegrid/obituary_detail/profile/hideDod&orderby=@jcr:content/root/responsivegrid/obituary_detail/profile/${orderBy}&orderby.sort=${orderBySort}&p.offset=${offset}&p.limit=${limit}&5_property=jcr:content/root/responsivegrid/obituary_detail/profile/enabled&5_property.value=true`;

  return validQuery;
};

const ObitsListingService: IObitsListingService = {
  searchObits: async (itemsPath: string, params: IObitsSearchParams) => {
    try {
      const res = await axios.get(
        `${itemsPath.replace("ca/fr", "ca/en")}.obits.json?${getValidQuery(
          params
        )}`
      );
      return res.data;
    } catch (err) {
      // handle error
    }
  },
};

export default ObitsListingService;
